import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

export const FETCH_ATELIERSEARCH_BEGIN = "FETCH_ATELIERSEARCH_BEGIN"
export const FETCH_ATELIERSEARCH_SUCCESS = "FETCH_ATELIERSEARCH_SUCCESS"
export const FETCH_ATELIERSEARCH_ERROR = "FETCH_ATELIERSEARCH_ERROR"
export const ATELIERSEARCH_TOGGLE_HIDERESULT = "ATELIERSEARCH_TOGGLE_HIDERESULT"

export const fetchAtelierSearchBegin = () => ({
	type: FETCH_ATELIERSEARCH_BEGIN,
})

export const fetchAtelierSearchSuccess = (atelierFiches) => ({
	type: FETCH_ATELIERSEARCH_SUCCESS,
	payload: { atelierFiches },
})

export const fetchAtelierSearchError = (error) => ({
	type: FETCH_ATELIERSEARCH_ERROR,
	payload: { error },
})

export function fetchAtelierSearch(kwargs) {
	let url = `${URL}api/ateliers?nom=${kwargs.nom}&marque=${kwargs.marque}&plaques=${kwargs.plaques}&employe=${kwargs.employe}&etat=${kwargs.etat}&dateT=${kwargs.dateT}&dateE=${kwargs.dateE}&dateS=${kwargs.dateS}&boss=${kwargs.boss}&svp=${kwargs.svp}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierSearchBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAtelierSearchSuccess(json)).then(
					dispatch(atelierSearchToggleHideresult()),
				)
			})
			.catch(catchApiError(dispatch, fetchAtelierSearchError))
	}
}

export const atelierSearchToggleHideresult = () => ({
	type: ATELIERSEARCH_TOGGLE_HIDERESULT,
})

// --- V2 : recherche en 2 pages (formulaire / résultats) -------------------
export const SET_ATELIER_SEARCH_CRITERES = "SET_ATELIER_SEARCH_CRITERES"
export const SET_ATELIER_SEARCH_RESULTS = "SET_ATELIER_SEARCH_RESULTS"

// Mémorise les critères saisis pour pré-remplir le formulaire au retour.
export const setAtelierSearchCriteres = (criteres) => ({
	type: SET_ATELIER_SEARCH_CRITERES,
	payload: { criteres },
})

// Remplace la liste de résultats (utilisé par le tri pour garder l'ordre
// affiché == ordre redux == ordre de feuilletage Page Up/Down de la fiche).
export const setAtelierSearchResults = (atelierFiches) => ({
	type: SET_ATELIER_SEARCH_RESULTS,
	payload: { atelierFiches },
})

// Version V2 : pas de toggle hideResult (la navigation gère le changement de
// page), renvoie le json pour permettre `.then(() => history.push(...))`.
export function fetchAtelierSearchV2(kwargs) {
	let url = `${URL}api/ateliers?nom=${kwargs.nom}&marque=${kwargs.marque}&plaques=${kwargs.plaques}&employe=${kwargs.employe}&etat=${kwargs.etat}&dateT=${kwargs.dateT}&dateE=${kwargs.dateE}&dateS=${kwargs.dateS}&boss=${kwargs.boss}&svp=${kwargs.svp}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierSearchBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAtelierSearchSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, fetchAtelierSearchError))
	}
}

// DELETE_ATELIER

export const DELETE_ATELIER_BEGIN = "DELETE_ATELIER_BEGIN"
export const DELETE_ATELIER_SUCCESS = "DELETE_ATELIER_SUCCESS"
export const DELETE_ATELIER_ERROR = "DELETE_ATELIER_ERROR"
export const DELETE_ATELIER_RESET = "DELETE_ATELIER_RESET"

export const deleteAtelierBegin = (ticket) => ({
	type: DELETE_ATELIER_BEGIN,
	payload: { ticket },
})

export const deleteAtelierSuccess = (atelierFiches, ticket, id, relance) => ({
	type: DELETE_ATELIER_SUCCESS,
	payload: { atelierFiches, ticket, id, relance },
})

export const deleteAtelierError = (error, ticket) => ({
	type: DELETE_ATELIER_ERROR,
	payload: { error, ticket },
})

export const deleteAtelierReset = () => ({
	type: DELETE_ATELIER_RESET,
})

// Ticket de chaque suppression : une réponse arrivée après un RESET (page
// quittée en pleine suppression, autre fiche ouverte depuis) ne s'affiche
// pas dans le modal d'une autre fiche — seule la ligne supprimée quitte la
// liste (reducer).
let ticketSuppression = 0

// silent=true pour les résultats (ResultDeleteModal affiche l'erreur) ; la
// fiche (SaveAtelierV2) n'a pas de surface d'erreur → toast par défaut.
export function deleteAtelier(kwargs, silent = false) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		const ticket = ++ticketSuppression
		// Sans `search`, le DELETE ne relance rien (réponse []) : le reducer
		// retire alors la ligne au lieu de vider la liste.
		const { id, search } = JSON.parse(kwargs)
		const relance = search !== undefined && search !== null
		dispatch(deleteAtelierBegin(ticket))
		return fetch(`${URL}api/ateliers`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) =>
				dispatch(deleteAtelierSuccess(json, ticket, id, relance)),
			)
			.catch(
				catchApiError(
					dispatch,
					(error) => deleteAtelierError(error, ticket),
					{ silent },
				),
			)
	}
}
